import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

/**
 * v149.32 — Screens that belong to the account OWNER (Wallet, Settings and
 * its sub-pages, Upgrade/plan change). A staff session — someone acting for
 * a brand they hold a staff seat on — is sent back to the dashboard no
 * matter how it got here: menu, an in-page link, the back button or a
 * typed URL. The matching API endpoints are owner-only on the server too
 * (`deps.deny_staff`), so this is the UX half, not the security boundary.
 */
export default function OwnerOnlyRoute({ children, label = "This page" }) {
  const { user } = useAuth();
  if (user?.is_staff) return <StaffBounce label={label} />;
  return children;
}

function StaffBounce({ label }) {
  useEffect(() => {
    toast.info(`${label} is only available to the account owner.`, { id: "owner-only-route" });
  }, [label]);
  return <Navigate to="/app" replace />;
}
